import { render } from "./ReactivationFailed.vue?vue&type=template&id=156f4fbc"
import script from "./ReactivationFailed.vue?vue&type=script&lang=js"
export * from "./ReactivationFailed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__